import React from 'react';
import { SignOutInfo } from 'src/features/header/store/slice';
import { HeaderLink } from 'src/features/header/components/styles';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

const signOutLinkTaktId = 'aac-sign-out-link';

interface SignOutLinkProps {
  signOutInfo: SignOutInfo;
  inverted?: boolean;
}

export const SignOutLink: React.VFC<SignOutLinkProps> = ({
  signOutInfo,
  inverted,
}) => {
  return (
    <HeaderLink
      size="small"
      data-ccx-e2e-id={signOutLinkTaktId}
      href={signOutInfo.url}
      inverted={inverted}
      {...getTaktAttributes(signOutLinkTaktId, chromeComponents.HEADER)}
    >
      {signOutInfo.label}
    </HeaderLink>
  );
};

export default SignOutLink;
